import {FirmStatusFilterItem} from '~/components/advanced_table'
import {getFirmStatus} from '~/helpers'

const FIRM_STATUSES = [
	{id: 'active', t: 'common.status.active'},
	{id: 'demo', t: 'common.status.demo'},
	{id: 'inactive', t: 'common.status.inactive'},
	{id: 'expired', t: 'common.status.expired'},
	{id: 'eitje', t: 'common.status.eitje'},
]

export const useFirmStatusFilter = () => {
	const filterFn = (item, filterValues) => {
		if (item.tableName === 'environments') {
			return filterValues.includes(item.status)
		} else {
			const status = getFirmStatus(item.environments)
			return filterValues.includes(status)
		}
	}

	return {
		items: FIRM_STATUSES,
		filterFn,
		ItemComponent: FirmStatusFilterItem,
	}
}
